import { useModal } from '@shared/model/useModal';

export const useVacationModal = () => useModal('vacation')
